import React from "react";
//import { getAgentList } from "../../Redux/Actions/webAppActions";
//import TextField from "@material-ui/core/TextField";
import AutoComplete1 from "../../Utils/Select";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { getCampaignList } from "../../Redux/Actions/webAppActions";
import moment from "moment";
import { mandatoryFileds } from "../../Utils/StaticData/MandatoryFields";
import { DataValidation, VERDA_CONSTS } from "../../Utils/StaticData/Constant";
//const defaultAgent = { label: "select", value: "" };
const defaultgender = { label: "select", value: "" };
const defaultpermissionToContact = { label: "select", value: "" };
const defaultstatusType = { label: "select", value: "" };
const defaultplanType = { label: "select", value: "" };
const defaultcampaignName = { label: "select", value: "" };
const defaultlanguage = { label: "select", value: "" };
const defaultEligiblePartA = { label: "select", value: "" };
const defaultEligiblePartB = { label: "select", value: "" };
const defaultEligiblePartD = { label: "select", value: "" };
const permissionToContact = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];
const eligibleForPartA = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];
const eligibleForPartB = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];
const eligibleForPartD = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];
const statusType = [
  { label: "Open", value: "Open" },
  { label: "Hold", value: "Hold" },
  { label: "Closed", value: "Closed" },
];
const gender = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
  // { label: "Unknown", value: "U" },
];
const planType = [
  { label: "MAPD", value: "1" },
  { label: "MA", value: "2" },
  { label: "PDP", value: "3" },
  { label: "MEDIGAP", value: "4" },
];
const campaignName = [
  { label: "Direct Mail", value: "Direct Mail" },
  { label: "TV", value: "TV" },
  { label: "Social Media", value: "Social Media" },
  { label: "Non-Campaign", value: "Non-Campaign" },
];
const language = [
  { label: "Arabic", value: "Ara" },
  { label: "Bengali", value: "Ben" },
  { label: "Chinese", value: "Chi" },
  { label: "Egyptian", value: "Egy" },
  { label: "Greek", value: "Gre" },
  { label: "English", value: "Eng" },
  { label: "French", value: "Fre" },
  { label: "Haitian", value: "Hai" },
  { label: "Creole", value: "Cre" },
  { label: "Italian", value: "Ita" },
  { label: "Japanese", value: "Jap" },
  { label: "Korean", value: "Kor" },
  { label: "Other", value: "Oth" },
];

const Prospect = (props) => {
  //const [assignedValue, setAssignedValue] = useState({ label: "", value: "" }); // for updating the assignedTo value

  // useEffect(() => {
  //   const filterValue = props.prospectagentList?.filter(
  //     (data) => data.value.trim() === props.data?.assignedTo?.trim()
  //   );

  //   if (filterValue.length === 2) {
  //     setAssignedValue(defaultAgent);
  //   } else {
  //     setAssignedValue({
  //       label: filterValue[0]?.value?.trim(),
  //       value: filterValue[0]?.label?.trim(),
  //     });
  //   }
  // }, [props.data.assignedTo, props.isRowSelectedInProspect]);
  useEffect(() => {
    props.getCampaignList("", "", "", "", props.customerId);
  }, []);
  // let allCampaignName = props.campaignData.map((d) => ({
  //   label: d.planCampaignName,
  //   value: d.enrlCampaignId,
  // }));
  let allCampaignName = props.campaignName;
  // if (
  //   props.customerId === VERDA_CONSTS.ID &&
  //   props.campaignName.some((c) => c?.label === "NO CAMPAIGN")
  // ) {
  //   allCampaignName.unshift({ label: "NO CAMPAIGN", value: "0" });
  // }
  return (
    <div
      id="prospect"
      class={
        props?.disable === true
          ? "tab-pane active disable-form"
          : "tab-pane active"
      }
    >
      <div class="panel-body container">
        <div class="form-panel2">
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_firstname" class="labelprospect">
                First Name <span class="mandatory-field">*</span>
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data.firstName === ""
                    ? "error-inputprospect w-236px"
                    : "form-control1 w-236px"
                }
                name="firstName"
                value={props.data.firstName}
                maxLength="20"
                onChange={(event) => {
                  if (
                    event.target.value !== "" &&
                    !DataValidation.test(event.target.value)
                  ) {
                    return;
                  }
                  props.handleChange(event);
                }}
                //class="form-control width15"
              />
              {/* <TextField
                  name="firstName"
                  error={
                    //props.prospectSaveFlag?
                    props.data?.firstName === ""
                  }
                  value={props.data.firstName}
                  size="small"
                  // inputProps={{style:{width:"9rem"}}}
                  className="prospectwidth9"
                  onChange={props.handleChange}
                  label="First Name*"
                  variant="outlined"
                /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_middlename" class="labelprospect">
                Middle Initial
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                name="middleInitial"
                value={props.data.middleInitial}
                maxLength="1"
                onChange={(event) => {
                  if (
                    event.target.value !== "" &&
                    !DataValidation.test(event.target.value)
                  ) {
                    return;
                  }
                  props.handleChange(event);
                }}
                class="form-control1 w-236px"
                id="prospect_middlename"
              />
              {/* <TextField
                  name="middleInitial"
                  value={props.data.middleInitial}
                  size="small"
                  className="prospectwidth9"
                  onChange={props.handleChange}
                  label="Middle Initial"
                  variant="outlined"
                /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_lastname" class="labelprospect">
                Last Name <span class="mandatory-field">*</span>
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data.lastName === ""
                    ? "error-inputprospect w-236px"
                    : "form-control1 w-236px"
                }
                //class="form-control width15"
                id="prospect_lastname"
                name="lastName"
                value={props.data.lastName}
                maxLength="20"
                onChange={(event) => {
                  if (
                    event.target.value !== "" &&
                    !DataValidation.test(event.target.value)
                  ) {
                    return;
                  }
                  props.handleChange(event);
                }}
              />
              {/* <TextField
                  name="lastName"
                  error={
                    //props.prospectSaveFlag?
                    props.data?.lastName === ""
                  }
                  value={props.data.lastName}
                  size="small"
                  className="prospectwidth9"
                  onChange={props.handleChange}
                  label="Last Name*"
                  variant="outlined"
                /> */}
            </span>
          </div>
          {/* secondrow */}
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_mbi" class="labelprospect">
                MBI
                {/* <span class="mandatory-field">*</span> */}
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={"form-control1 w-236px"}
                //class="form-control width15"
                name="mbi"
                value={props.data.mbi}
                maxLength="11"
                onChange={props.handleChange}
              />
              {/* <TextField
                  name="mbi"
                  value={props.data.mbi}
                  // error={
                  //props.prospectSaveFlag?
                  // (props.data?.mbi === "" ||(props.data?.mbi && props?.mandatoryMbi?.length < 11))}
                  size="small"
                  inputProps={{ maxLength: 11 }}
                  className="prospectwidth9"
                  onChange={props.handleChange}
                  label="MBI"
                  variant="outlined"
                /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_dateofbirth" class="labelprospect">
                Date of Birth <span class="mandatory-field">*</span>
              </label>
              <br />
              {/* <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                  type="date"
                  //class="form-control width15"
                  id="prospect_dateofbirth"
                  name="dob"
                  class={props.data.dob === "" ? "error-input" : "form-control"}
                  value={props.data.dob}
                  onChange={props.handleChange}
                /> */}
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                class={
                  //props.prospectSaveFlag?
                  props.data.dob === "" ||
                  !moment(props.data.dob, "MM/DD/YYYY", true).isValid()
                    ? "error-inputdashboard1 scrollfix"
                    : "form-control2dashboard scrollfix"
                  // :"form-control1dashboard prospectdate"
                }
                value={props.data.dob}
                maxLength="10"
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("dob")}
                name="dob"
                id="dob"
                placeholder="MM/DD/YYYY"
                required=""
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_gender" class="labelprospect">
                Gender <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                error={
                  //props.prospectSaveFlag?
                  props.data.gender === "" ||
                  gender.filter((data1) => data1.value === props.data.gender)
                    ?.length === 0
                }
                handleChange={props.handleOtherDropdown("gender")}
                options={gender}
                value={
                  gender.filter((data1) => data1.value === props.data.gender)
                    .length !== 0
                    ? gender.filter(
                        (data1) => data1.value === props.data.gender
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={defaultgender}
                //value={props.data.preferredLang}
                name="gender"
                //className="select-normal1"
                // className={
                //   props.data.gender === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
                // {
                //   // props.data.assignedTo===""? "error-input1":"select-normal1"
                //   props.data.gender === ""
                //     ? "select-normal1"
                //     : "select-normal1"
                // }
              />
            </span>
          </div>
          <div class="row">
            {/* <label for="prospect_mbi" class="labelprospect">
                  MBI <span class="mandatory-field">*</span>
                </label>
                <br />
                <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                  type="text"
                  name="mbi"
                  placeholder="XXXXXXXXXXX"
                  value={props.data.mbi}
                  onChange={props.handleChange}
                  //class="form-control width15"
                  class={
                    props.data.mbi === "" ||
                    (props.data.mbi && props.data.mbi.length < 10)
                      ? "error-inputprospect"
                      : "form-control1"
                  }
                  id="prospect_mbi"
                  minlength="10"
                  maxLength="11"
                  required=""
                /> */}

            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_eligibleForPartA" class="labelprospect">
                Eligible for Part A
              </label>
              <br />
              {/* <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                  type="text"
                  class="form-control1 width15"
                  id="prospect_eligibleForPartA"
                  name="eligibleForPartA"
                  value={props.data.eligibleForPartA}
                  onChange={props.handleChange}
                /> */}
              {/* <AutoComplete1
                  handleChange={props.handleOtherDropdown("eligibleForPartA")}
                  options={eligibleForPartA}
                  value={
                    eligibleForPartA.filter(
                      (data1) => data1.value === props.data.eligibleForPartA
                    ).length !==0 ?
                    eligibleForPartA.filter(
                      (data1) => data1.value === props.data.eligibleForPartA
                    )[0]:{
                      label: "select", value: ""
                    }
                  }
                  defaultValue={defaultEligiblePartA}
                  name="eligibleForPartA"
                  className="select-normaleligible"
                /> */}
              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                handleChange={props.handleOtherDropdown("eligibleForPartA")}
                options={eligibleForPartA}
                value={
                  eligibleForPartA.filter(
                    (data1) => data1.value === props.data.eligibleForPartA
                  ).length !== 0
                    ? eligibleForPartA.filter(
                        (data1) => data1.value === props.data.eligibleForPartA
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={defaultEligiblePartA}
                name="eligibleForPartA"
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_eligibleForPartB" class="labelprospect">
                Eligible for Part B
              </label>
              <br />
              {/* <AutoComplete1
                  handleChange={props.handleOtherDropdown("eligibleForPartB")}
                  options={eligibleForPartB}
                  value={
                    eligibleForPartB.filter(
                      (data1) => data1.value === props.data.eligibleForPartB
                    ).length !==0 ?
                    eligibleForPartB.filter(
                      (data1) => data1.value === props.data.eligibleForPartB
                    )[0]:{
                      label: "select", value: ""
                    }
                  }
                  defaultValue={defaultEligiblePartB}
                 
                  name="eligibleForPartB"
                  className="select-normaleligible"
                /> */}
              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                handleChange={props.handleOtherDropdown("eligibleForPartB")}
                options={eligibleForPartB}
                value={
                  eligibleForPartB.filter(
                    (data1) => data1.value === props.data.eligibleForPartB
                  ).length !== 0
                    ? eligibleForPartB.filter(
                        (data1) => data1.value === props.data.eligibleForPartB
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={defaultEligiblePartB}
                name="eligibleForPartB"
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_eligibleForPartD" class="labelprospect">
                Eligible for Part D
              </label>
              <br />
              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                handleChange={props.handleOtherDropdown("eligibleForPartD")}
                options={eligibleForPartD}
                value={
                  eligibleForPartD.filter(
                    (data1) => data1.value === props.data.eligibleForPartD
                  ).length !== 0
                    ? eligibleForPartD.filter(
                        (data1) => data1.value === props.data.eligibleForPartD
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={defaultEligiblePartD}
                name="eligibleForPartD"
                // className="select-normaleligible"
              />
            </span>
          </div>
          {/* 4throw */}
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_permission2contact" class="labelprospect">
                Permission to contact <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                error={
                  //props.prospectSaveFlag?
                  props.data.permissionToContact === "" ||
                  permissionToContact.filter(
                    (data1) => data1.value === props.data.permissionToContact
                  ).length == 0
                }
                handleChange={props.handleOtherDropdown("permissionToContact")}
                options={permissionToContact}
                value={
                  permissionToContact.filter(
                    (data1) => data1.value === props.data.permissionToContact
                  ).length !== 0
                    ? permissionToContact.filter(
                        (data1) =>
                          data1.value === props.data.permissionToContact
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={
                  // permissionToContact.filter(
                  //   (data1) => data1.value === props.data.permissionToContact
                  // )[0]
                  defaultpermissionToContact
                }
                //value={props.data.preferredLang}
                name="permissionToContact"
                //className="select-normal1"
                // className={
                //   props.data.permissionToContact === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_preferred_language" class="labelprospect">
                Preferred Language <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                error={
                  // props.prospectSaveFlag?
                  props.data.preferredLang === "" ||
                  language.filter(
                    (data1) => data1.value === props.data.preferredLang
                  ).length == 0
                }
                handleChange={props.handleOtherDropdown("preferredLang")}
                options={language}
                value={
                  language.filter(
                    (data1) => data1.value === props.data.preferredLang
                  ).length !== 0
                    ? language.filter(
                        (data1) => data1.value === props.data.preferredLang
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                //value={props.data.preferredLang}
                name="preferredLang"
                defaultValue={
                  // language.filter(
                  //   (data1) => data1.value === props.data.preferredLang
                  // )[0]
                  defaultlanguage
                }
                //className="select-normal1"
                // className={
                //   props.data.preferredLang === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
                // {
                //   // props.data.assignedTo===""? "error-input1":"select-normal1"
                //   props.data.preferredLang === ""
                //     ? "select-normal1"
                //     : "select-normal1"
                // }
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_plan_campaign_name" class="labelprospect">
                Plan Campaign Name{" "}
                {
                // !mandatoryFileds[props.customerId]?.prospectManagement
                //   ?.PlanCampaignName 
                props?.supportingServices.every((servc)=>servc!=="ENRLSVC1")
                  ? (
                  ""
                ) : (
                  <span class="mandatory-field">*</span>
                )}
              </label>
              <br />
              {/* <AutoComplete1
                  handleChange={props.handleOtherDropdown("planCampaignName")}
                  options={campaignName}
                  value={
                    campaignName.filter(
                      (data1) => data1.value === props.data.planCampaignName
                    )[0]
                  }
                  defaultValue={
                    // campaignName.filter(
                    //   (data1) => data1.value === props.data.planCampaignName
                    // )[0]
                    defaultcampaignName
                  }
                  //value={props.data.preferredLang}
                  name="planCampaignName"
                  //className="select-normal1"
                  className={
                    props.data.planCampaignName === ""
                      ? "select-error1"
                      : "select-normal1"
                  }
                /> */}
              <AutoComplete1
                field="plancampaignName"
                dashboard="prospect"
                height="7px !important"
                width="236px"
                error={
                  // !mandatoryFileds[props.customerId]?.prospectManagement
                  //   ?.PlanCampaignName
                  props?.supportingServices.every((servc1)=>servc1!=="ENRLSVC1")
                    ? false
                    : //props.prospectSaveFlag?
                      props.data.planCampaignName === "" ||
                      props.data.planCampaignName === null ||
                      props.data.planCampaignName === undefined ||
                      allCampaignName.filter((data1) =>
                        Array.isArray(props.data.planCampaignName)
                          ? props.data.planCampaignName?.some(
                              (p) => p === data1.value
                            ) === true
                          : props.data.planCampaignName === data1.value
                      )?.length === 0
                }
                // handleChange={props.handleOtherDropdown("planCampaignName")}
                handleChange={props.handleMultipleSelectionDropdown(
                  "planCampaignName"
                )}
                options={props.campaignName.filter(
                  (com) => com.status === "Open"
                )}
                value={
                  // allCampaignName.filter(
                  //   (data1) => data1.value === props.data.planCampaignName
                  // ).length !== 0
                  allCampaignName.filter((data1) =>
                    Array.isArray(props.data.planCampaignName)
                      ? props.data.planCampaignName?.some(
                          (p) => p === data1.value
                        ) === true
                      : props.data.planCampaignName === data1.value
                  )
                  // : {
                  //     label: "select",
                  //     value: "",
                  //   }
                }
                defaultValue={defaultcampaignName}
                // defaultValue={
                //   // campaignName.filter(
                //   //   (data1) => data1.value === props.data.planCampaignName
                //   // )[0]
                //   defaultcampaignName
                // }
                //value={props.data.preferredLang}
                name="planCampaignName"
                //className="select-normal1"
                // className={
                //   props.data.planCampaignName === "" || props.data.planCampaignName===null || props.data.planCampaignName===undefined
                //     ? "select-error1"
                //     : "select-normal1"
                // }
                multiple={true}
              />
            </span>
          </div>
          {/* 5th row */}
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_plan_type" class="labelprospect">
                Plan Type <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                multiple={true}
                handleChange={props.handleMultipleSelectionDropdown("planType")}
                error={
                  props.data.planType?.length < 1 ||
                  planType.filter(
                    (data1) => props.data.planType?.indexOf(data1.value) !== -1
                  ).length === 0
                    ? true
                    : false
                }
                // handleChange={props.handleOtherDropdown("planType")}
                options={planType}
                value={planType.filter(
                  (data1) => props.data.planType?.indexOf(data1.value) !== -1
                )}
                // value={
                //   planType.filter(
                //     (data1) => data1.value === props.data.planType
                //   )[0]
                // }
                defaultValue={
                  // planType.filter(
                  //   (data1) => data1.value === props.data.planType
                  // )[0]
                  defaultplanType
                }
                name="planType"
                //className="select-normal1"
                // className={
                //   props.data.planType === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_status_type" class="labelprospect">
                Status Type <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                height="7px !important"
                width="236px"
                error={
                  //props.prospectSaveFlag?
                  props.data.statusType === "" ||
                  statusType.filter(
                    (data1) => data1.value === props.data.statusType
                  ).length == 0
                }
                handleChange={props.handleOtherDropdown("statusType")}
                options={
                  props.newProspect === true
                    ? statusType.slice(0, 2)
                    : statusType
                }
                value={
                  statusType.filter(
                    (data1) => data1.value === props.data.statusType
                  ).length !== 0
                    ? statusType.filter(
                        (data1) => data1.value === props.data.statusType
                      )[0]
                    : {
                        label: "select",
                        value: "",
                      }
                }
                defaultValue={
                  // statusType.filter(
                  //   (data1) => data1.value === props.data.statusType
                  // )[0]
                  defaultstatusType
                }
                //value={props.data.preferredLang}
                name="statusType"
                //className="select-normal1"
                // className={
                //   props.data.statusType === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
              />
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_assigned_to" class="labelprospect">
                Assigned To <span class="mandatory-field">*</span>
              </label>
              <br />

              <AutoComplete1
                dashboard="prospect"
                width="236px"
                height="7px !important"
                field="assignedTo"
                error={
                  // props.prospectSaveFlag?
                  props.data.assignedTo === "" ||
                  props.prospectagentList.filter(
                    (data1) =>
                      data1.value ===
                      (props?.data?.assignedTo &&
                        props?.data?.assignedTo?.trim()) ||
                        data1.label.trim() ===
                      (props?.data?.assignedTo &&
                        props?.data?.assignedTo?.trim())
                  ).length == 0
                }
                handleChange={props.handleDropdown("assignedTo")}
                options={props.prospectagentList}
                disabled={!props?.isSuperUser}
                // {props.prospectagentList?.map((data) => ({
                //   label: data.value,
                //   value: data.label,
                // }))}
                //value={assignedValue}
                value={
                  props.prospectagentList?.length > 1 &&
                  props.prospectagentList.filter(
                    (data1) =>
                      data1.value ===
                      (props?.data?.assignedTo && props.data.assignedTo?.trim()) ||
                      data1.label.trim() ===
                      (props?.data?.assignedTo &&
                        props?.data?.assignedTo?.trim())
                  ).length !== 0
                    ? props.prospectagentList.filter(
                        (data1) =>
                          data1.value ===
                          (props?.data?.assignedTo &&
                            props.data.assignedTo?.trim()) ||
                            data1.label.trim() ===
                      (props?.data?.assignedTo &&
                        props?.data?.assignedTo?.trim())
                      )[0]
                    : ""
                }
                //defaultValue={}
                name="assignedTo"
                // className={
                //   props.data.assignedTo === ""
                //     ? "select-error1"
                //     : "select-normal1"
                // }
                //className="select-normal1"
              />
              {/* </div> */}
            </span>
          </div>
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_lead_id_number" class="labelprospect">
                Lead ID number
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                name="leadIdNbr"
                onChange={props.handleChange}
                class="form-control1 height-33px setTopp font-10px w-236px readonly"
                id="prospect_lead_id_number"
                readonly=""
                disabled
                value={
                  props.newProspect
                    ? ""
                    : props.data.leadIdNbr
                    ? props.data.leadIdNbr
                    : props.leadIdNbr
                }
              />
              {/* <TextField
                  disabled
                  name="leadIdNbr"
                  value={
                    props.newProspect
                      ? ""
                      : props.data.leadIdNbr
                      ? props.data.leadIdNbr
                      : props.leadIdNbr
                  }
                  size="small"
                  className="prospectwidth9 prospectDark-text"
                  onChange={props.handleChange}
                  label="Lead ID number"
                  variant="outlined"
                /> */}
            </span>
          </div>
          {/* 6th row */}
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_create_time" class="labelprospect">
                Create Time
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class="form-control1 height-33px setTopp font-10px w-236px readonly"
                name="createdTime"
                disabled
                value={props.data.createdTime}
                readonly=""
                //onChange={props.handleChange}
              />
              {/* <TextField
                  disabled
                  name="createdTime"
                  value={props.data.createdTime}
                  size="small"
                  className="prospectwidth9 prospectDark-text"
                  //onChange={props.handleChange}
                  label="Create Time"
                  variant="outlined"
                /> */}
            </span>

            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_user" class="labelprospect">
                Create User
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class="form-control1 height-33px setTopp font-10px w-236px readonly"
                name="createdBy"
                disabled
                value={props.data.createdBy}
                readonly=""
                onChange={props.handleChange}
              />
              {/* <TextField
                  disabled
                  name="createdBy"
                  value={props.data.createdBy}
                  size="small"
                  className="prospectwidth9 prospectDark-text"
                  onChange={props.handleChange}
                  label="Create User"
                  variant="outlined"
                /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_modified_time" class="labelprospect">
                Modified Time
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class="form-control1 height-33px setTopp font-10px w-236px readonly"
                id="prospect_modified_time"
                readonly=""
                name="updatedTime"
                value={props.data.updatedTime}
                onChange={props.handleChange}
              />
              {/* <TextField
                  disabled
                  name="updatedTime"
                  value={props.data.updatedTime}
                  size="small"
                  className="prospectwidth9 prospectDark-text"
                  onChange={props.handleChange}
                  label="Modified Time"
                  variant="outlined"
                /> */}
            </span>
          </div>
          <div class="row">
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label for="prospect_modified_user" class="labelprospect">
                Modified User
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class="form-control1 height-33px setTopp font-10px w-236px readonly"
                readonly=""
                name="updatedBy"
                value={props.data.updatedBy}
                disabled
                onChange={props.handleChange}
              />
              {/* <TextField
                  disabled
                  name="updatedBy"
                  value={props.data.updatedBy}
                  size="small"
                  className="prospectwidth9 prospectDark-text"
                  onChange={props.handleChange}
                  label="Modified User"
                  variant="outlined"
                /> */}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    lang: state.webApp.language,
    // prospectagentList: state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    campaignName: state.campaignProspect.campaignNamesList,
    customerId: state.login.customerId,
    campaignData: state.campaignProspect.campaignData,
    supportingServices:state.login.supportingServices,
  };
};
const mapDispatchToProps = {
  getCampaignList,
};
export default connect(mapStateToProps, mapDispatchToProps)(Prospect);
